<template>
    <div class="nk-app-root">
        <!-- main @s -->
        <div class="nk-main ">
            <!-- wrap @s -->
            <div class="nk-wrap nk-wrap-nosidebar">
                <!-- content @s -->
                <div class="nk-content ">
                    <div class="nk-split nk-split-page nk-split-lg">
                        <div class="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                            <div class="absolute-top-right d-lg-none p-3 p-sm-5">
                                <a href="javascript:void(0)" class="toggle btn-white btn btn-icon btn-light" data-target="athPromo"><em class="icon ni ni-info"></em></a>
                            </div>
                            <div class="nk-block nk-block-middle nk-auth-body">
                                <div class="brand-logo pb-5">
                                    <a href="javascript:void(0)" class="logo-link">
                                        <img class="logo-light logo-img logo-img-lg" src="/images/logo.png" alt="logo">
                                        <img class="logo-dark logo-img logo-img-lg" src="/images/logo.png" alt="logo-dark">
                                    </a>
                                </div>
                                <div class="nk-block-head">
                                    <div class="nk-block-head-content">
                                        <h5 class="nk-block-title">Register</h5>
                                    </div>
                                </div><!-- .nk-block-head -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label">Referral Link</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="$v.registeruser.referrerNo.$model" v-bind:disabled="referrerNo!='' && referrerNo!=null && referrerNo!=undefined" type="text" class="form-control form-control-lg">
                                        <span v-if="$v.registeruser.referrerNo.$error" class="error">
                                            <span v-if="!$v.registeruser.referrerNo.required">Referrer No Is Required </span>
                                        </span>
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label">First Name</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="$v.registeruser.firstName.$model" type="text" class="form-control form-control-lg">
                                        <span v-if="$v.registeruser.firstName.$error" class="error">
                                            <span v-if="!$v.registeruser.firstName.required">First Name Is Required </span>
                                        </span>
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label">Middle Name</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="registeruser.middleName" type="text" class="form-control form-control-lg">
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label">Last Name</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="registeruser.lastName" type="text" class="form-control form-control-lg">
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group" v-if="false">
                                    <div class="form-label-group">
                                        <label class="form-label">CNIC / National Id</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="$v.registeruser.cnic.$model" type="number" class="form-control form-control-lg">
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label">Username</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="$v.registeruser.username.$model" type="text" class="form-control form-control-lg">
                                        <span v-if="$v.registeruser.username.$error" class="error">
                                            <span v-if="!$v.registeruser.username.required">User Name Is Required </span>
                                            <span v-if="!$v.registeruser.username.maxLength">User Name has maximum Length 20 </span>
                                            <span v-if="!$v.registeruser.username.strongUserName">Wrong User Name </span>
                                        </span>
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label">Email</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="$v.registeruser.email.$model" type="text" class="form-control form-control-lg">
                                        <span v-if="$v.registeruser.email.$error" class="error">
                                            <span v-if="!$v.registeruser.email.required">Email Is Required </span>
                                            <span v-if="!$v.registeruser.email.email">Email not valid </span>
                                        </span>
                                    </div>
                                </div><!-- .form-group -->

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label" for="password">Password</label>
                                    </div>
                                    <div class="form-control-wrap">                                        
                                        <input v-model="$v.registeruser.password.$model" v-bind:type="show? 'text' : 'password'" class="form-control form-control-lg" >
                                        <span v-if="$v.registeruser.password.$error" class="error">
                                            <span v-if="!$v.registeruser.password.required">Password Is Required </span>
                                            <span v-if="!$v.registeruser.password.strongPassword">Use Strong Password </span>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-label-group">
                                        <label class="form-label" for="confirm-password">Confirm Password</label>
                                    </div>
                                    <div class="form-control-wrap">
                                        <input v-model="$v.registeruser.confirmPassword.$model" v-bind:type="show? 'text' : 'password'" class="form-control form-control-lg">
                                        <span v-if="$v.registeruser.confirmPassword.$error" class="error">
                                            <span v-if="!$v.registeruser.confirmPassword.required">Confirm Password Is Required </span>
                                            <span v-if="!$v.registeruser.confirmPassword.sameAsPassword">Password Not Matched </span>
                                        </span>
                                    </div>
                                    <a v-on:click="ShowPassword()" class="link link-primary link-sm" href="javascript:void(0)">Show Password</a>

                                </div>

                                <div class="form-group">
                                    <div class="custom-control custom-control-xs custom-checkbox">
                                        <input v-model="registeruser.termsAndCondition" type="checkbox" class="custom-control-input" id="checkbox">
                                        <label class="custom-control-label" for="checkbox">I agree to Black Stone Capitals <a tabindex="-1" href="javascript:void(0)" v-on:click="GoToTerms()">Privacy Policy</a> &amp; <a tabindex="-1" href="javascript:void(0)" v-on:click="GoToTerms()"> Terms.</a></label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <button v-bind:disabled="$v.$invalid || !registeruser.termsAndCondition" v-on:click="SaveNewUser" class="btn btn-lg btn-primary btn-block">Register</button>
                                </div>

                                <div class="form-note-s2 pt-4">
                                    Already have an account? <a href="javascript:void(0)" v-on:click="GoToSignIn()">Login Account</a>
                                </div>

                            </div><!-- .nk-block -->
                            <div class="nk-block nk-auth-footer">
                                <div class="nk-block-between">
                                    <ul class="nav nav-sm">
                                        <li class="nav-item">
                                            <a v-on:click="GoToTerms()" class="nav-link" href="javascript:void(0)">Terms & Condition</a>
                                        </li>
                                        <li class="nav-item">
                                            <a v-on:click="GoToTerms()" class="nav-link" href="javascript:void(0)">Privacy Policy</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="mailto:support@blackstonecapitals.com">Help</a>
                                        </li>
                                        <li class="nav-item dropup">
                                            <a class="dropdown-toggle dropdown-indicator has-indicator nav-link" data-bs-toggle="dropdown" data-offset="0,10"><small>English</small></a>
                                            <div class="dropdown-menu dropdown-menu-sm dropdown-menu-end">
                                                <ul class="language-list">
                                                    <li>
                                                        <a href="#" class="language-item">
                                                            <img src="/images/flags/english.png" alt="" class="language-flag">
                                                            <span class="language-name">English</span>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="#" class="language-item">
                                                            <img src="/images/flags/turkey.png" alt="" class="language-flag">
                                                            <span class="language-name">T�rk�e</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    </ul><!-- .nav -->
                                </div>
                                <div class="mt-3">
                                    <p>&copy; 2022 Black Stone Capitals. All Rights Reserved.</p>
                                </div>
                            </div><!-- .nk-block -->
                        </div><!-- .nk-split-content -->
                        <div class="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right" data-toggle-body="true" data-content="athPromo" data-toggle-screen="lg" data-toggle-overlay="true">
                            <div class="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                                <div class="slider-init">
                                    <div class="slider-item">
                                        <div class="nk-feature nk-feature-center">
                                            <div class="nk-feature-img">
                                                <img class="round" src="/images/login.svg" alt="">
                                            </div>
                                            <!--<div class="nk-feature-content py-4 p-sm-4">
                                                <h4>Black Stone Capitals</h4>
                                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                                            </div>-->
                                        </div>
                                    </div><!-- .slider-item -->

                                </div><!-- .slider-init -->
                                <div class="slider-dots"></div>
                                <div class="slider-arrows"></div>
                            </div><!-- .slider-wrap -->
                        </div><!-- .nk-split-content -->
                    </div><!-- .nk-split -->
                </div>
                <!-- wrap @e -->
            </div>
            <!-- content @e -->
        </div>
        <!-- main @e -->

        <loading :name="loading" :active.sync="loading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
    <!-- app-root @e -->

</template>
<script>
    import { required, maxLength, sameAs, email } from 'vuelidate/lib/validators';
    import Loading from 'vue-loading-overlay';
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        components: {
            Loading
        },
        data() {
            return {
                show: false,
                loading: false,
                registeruser: {
                    id: '00000000-0000-0000-0000-000000000000',
                    email: '',
                    username: '',
                    referrerNo: '',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    phonenumber: '',
                    cnic: '',
                    password: '',
                    confirmPassword: '',
                    termsAndCondition: false,
                    isSignUp: true,
                },
                referrerNo:''
            }
        },
        validations: {
            registeruser:
            {
                firstName:
                {
                    required
                },
                cnic:
                {
                },
                username:
                {
                    required,
                    maxLength: maxLength(20),
                    strongUserName(username) {
                        return /^[a-zA-Z0-9]+$/.test(username);
                    }
                },
                email:
                {
                    required,
                    email
                },
                referrerNo:
                {
                    required
                },
                password:
                {
                    required,
                    strongPassword(password) {
                        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/.test(password);
                    }
                },
                confirmPassword:
                {
                    required,
                    sameAsPassword: sameAs('password')
                },
            }
        },

        methods: {
            GoToTerms: function () {
                this.$router.push('/TermsAndCondition')
            },

            ShowPassword: function () {
                if (this.show == false) {
                    this.show = true;
                }
                else {
                    this.show = false;
                }
            },
            
            GoToSignIn: function () {
                this.$router.push('/')
            },

            SaveNewUser: function () {
                var root = this;
                this.loading = true;
                
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/account/RegisterUser', this.registeruser, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        console.log(response.data)
                        if (response.data.id != '00000000-0000-0000-0000-000000000000' && response.data.isSuccess) {

                            root.SendEmailVerification(response.data.id);

                            root.$swal({
                                title: 'Created!',
                                text: 'User has been Created successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            });
                            root.loading = false;
                            root.$router.push('/EmailVerification')
                        }
                        else {
                            root.$swal({
                                title: 'Error!',
                                text: response.data.isAddUpdate,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                            root.loading = false;
                        }
                    }).catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                type: 'error',
                                title: 'Error',
                                text: "Something Went Wrong",
                                showConfirmButton: false,
                                timer: 5000,
                                timerProgressBar: true,
                            });

                        root.loading = false;
                    })
                    .finally(() => root.loading = false);
            },

            SendEmailVerification: function (id) {
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                this.$https.get('/account/SendEmailVerification?id=' + id, { headers: { "Authorization": `Bearer ${token}` } });

            },
        },
        created: function () {
            
            this.referrerNo = this.$route.query.referralNo;
            this.registeruser.referrerNo = this.$route.query.referralNo;
        },
    }
</script>
